
import React  ,{useEffect, useState, useRef}from 'react'
import { Image, Grid, GridColumn, GridRow , Button , Container, CommentText  } from 'semantic-ui-react';
import {map } from "lodash"
import {Link} from "react-router-dom"
import UserNot from "./UserNot/UserNot"
import Samples from "./Samples/Samples"
import logo from "./../../asets/png/logo.jpg"
//import zangano from "../../asets/png/zangano.png"
//import elzangano from "../../asets/png/elzangano.jpeg"
//import reina from "../../asets/png/reina.jpg" 
//import aveja from "../../asets/png/aveja.jpg"
import gans from "../../asets/png/gans.png"
//import mercado from "../../asets/png/mercado.png"
import niña from "../../asets/png/niña.png"
import cielo from "../../asets/png/cielo.png"
import flor from "../../asets/png/flor.png"
import ciudad from "../../asets/png/ciudad.png"
import { GETGLOBAL } from"../../gql/global"
import { useQuery } from '@apollo/client';
import { useMutation } from '@apollo/client';
import {COUNTGLOBAL} from "../../gql/global";
import useAuth from '../../hooks/useAuth';
import Visitas from './Visitas/Visitas';



import "./Bienvenida.scss"
import Footer from '../Homeventas/Footer/Footer';






function Bienvenida() {
  const {auth} = useAuth();

  
  console.log ( auth.id)
  //console.log(getGlobal[0].idUserAnt.username);
  
 const { data, loading, error, refetch, startPolling,stopPolling} = useQuery (GETGLOBAL,{variables: { id:"67355bb3437eedf7b8e59490" } ,});
     
  //const [global , setGloblal]= useState (null)
  //const { getGlobal } = data;
  //const [updateGlobal] = useMutation (COUNTGLOBAL);
  //console.log ("hola ")
       
//const ref = useRef(data)
//console.log (ref)
        
  //console.log ("hi")
  /*useEffect(() => {


    
    
    


  










    
    
    //setGloblal(getGlobal[0].idUser)
    //console.log (us
    return () => {
      try {

        
        updateGlobal({
          variables:{	input:{
            id:"67355bb3437eedf7b8e59490",
            countInt:getGlobal[0].countInt + 1 ,
    
            createAt:new Date(),
            idUser:auth.idUser,
            idUserAnt:globals[0].user2.id,
            //idUserAnt2:getGlobal[0].idUserAnt||getGlobal[0].idUserAnt2,
                    //createAt2:new Date(),
    
          }},
    
          
        });
    
        
       
      } catch (error) {
        console.log (error);
        
      }
    }
  }, [  ])
 // if (loading) return null ; 
 /* 
useEffect(() => {

  
          
  try {

    //const { getGlobal } = data;

    updateGlobal({
      variables:{	input:{
        id:"67355bb3437eedf7b8e59490",
        countInt:getGlobal[0].countInt + 1 ,

        createAt:new Date(),
        idUser:auth.idUser,
       idUserAnt:getGlobal[0].idUser||getGlobal[0].idUserAnt,
        idUserAnt2:getGlobal[0].idUserAnt||getGlobal[0].idUserAnt2,
                //createAt2:new Date(),

      }},

      
    });

    
   
  } catch (error) {
    console.log (error);
    
  }

    
   },[] )

   /*useEffect(() => {
  



    startPolling(1000000000)
    return () => {
     stopPolling();
    }
  }, [startPolling,stopPolling])
  
  
  /*const { data, loading, error, refetch, startPolling,stopPolling} = useQuery (GETGLOBAL,{
    variables: { id:"67355bb3437eedf7b8e59490" } ,
  });




if (loading) return null ; 
  const { getGlobal } = data; 
  console.log (data)
  refetch()  

*/
if (loading) return null ; 
const { getGlobal } = data; 
console.log (data)

const globals = [];


    data.getGlobal.forEach((global) => {
      globals.push({
          

          createAt:global.createAt,
          count:global.countInt,
          user1:global.idUser,
          user2:global.idUserAnt,
          user3:global.idUserAnt2,
          
          //ident:publi._id,
          
         

       } );
      



    });




console.log (globals)
console.log (globals[0].user2.id)
   
  return (
       <>
<div className='bien'>
<Grid class="six wide tablet eight wide computer column"   mobile = {16} computer={16}  >

 
<GridColumn className='homer' mobile = {16} computer={7}  >

  <h2>LA COLMENA </h2>


<Image src = {gans} centered circular />
<Link to = "/Category">
<Button positive fluid>Categorías</Button>
</Link>

</GridColumn>

       
       
      < GridColumn className='homer_righ'     mobile= {16}  computer={7} >
       
      <h2>Hola 😃 Bienvenid@</h2>
      <Grid columns={4} centered>
      <Grid.Row verticalAlign= "middle">
      <GridColumn>
      <Image src = {ciudad}  className='homer_righ_f' />
      </GridColumn>
      <GridColumn>
      <Image src = {cielo} circular className="homer_righ_f"  />
      <br />
      <Image src = {flor} circular className="homer_righ_f"  />
      </GridColumn>
      <GridColumn>
      <Image src = {niña}  className="homer_righ_f"  />
      </GridColumn>
      </Grid.Row>
      </Grid>


      <h3> Para iniciar CLICK en la home, visualiza las publicaciones de personas de tu comunidad, contacta  por medio de de whatsapp.
      </h3>
      </GridColumn>



    </Grid >

      <div>
    
      <Grid.Row className='homer_down'   mobile = {2} >
      <Samples  />
      
      </Grid.Row>
      </div>

      <div>
    
    <Grid.Row className='homer_down'   mobile = {2} >
    
    
    </Grid.Row>
    </div>



      </div>


<div >

<Visitas getGlobal = {getGlobal} auth={auth.idUser} globals={globals} auth1={auth.id} />


</div>


<Footer/>



      

    </>
        
      
    
    
      
         
  )
}

export default Bienvenida

